import * as React from "react";
import {cx} from "emotion";

import "./ad-budget-form.scss";

import {bindInput}    from "@Common/react/bind-input";
import {cs}           from "@Common/react/chain-services";
import {Form2}        from "@Common/react/cs-form-2/form2";
import {required}     from "@Common/react/cs-form-2/validators/required";
import {keyed}        from "@Common/react/keyed";
import {scopedState}  from "@Common/react/scoped-state";
import {UseState}     from "@Common/react/use-state";
import {snv}          from "@Common/utils/arr-path";
import {isSpecialKey} from "@Common/utils/browser/is-special-key";
import {chain2}       from "@Common/utils/fs";

import {getFields} from "./get-fields";
import {max} from "@Common/react/cs-form-2/validators/max";
import {isNumber} from "@Common/react/cs-form-2/validators/is-number";
import {Select} from "@Common/ui-components/heavy/common/design2/select/select";

export const AdBudgetForm = ({config, savedData=undefined, next}) => cs(
    ["fields", (_, next) => next(getFields({config, savedData}))],
    ["userData", ({fields}, next) => UseState({
        getInitValue: () => !savedData ? {} : chain2(
            {},
            fields.map((field) => (
                (_) => snv(_, [field.path], field.initData(savedData))
            )),
        ),
        next,
    })],
    ["form", ({fields, userData}, next) => Form2({
        data: userData,
        fields: fields?.map((field) => ({
            path: [field.path],
            validators: [
                field.required && required,
                field.maxValue && max(field.maxValue),
                field.type === "Number" && isNumber,
            ].filter(v=>v),
        })),
        next,
    })],
    ({fields, form, userData}) => next({
        valid: form.looksValid,
        submit: (onSubmit) => form.submit({
            onSubmit: ({data}) => onSubmit({
                ...data,
                ...(
                    data.billingAdjustment == null || data.billingAdjustment === "" || isNaN(data.billingAdjustment) ? (
                        null
                    ) : ({
                        billingAdjustment: +data.billingAdjustment
                    })
                ),
            }),
        }),
        render: ({className, readOnly}) => cs(
            ["field", ({}, next) => (
                <div className={cx("ad-budget-form-view-2pp", className)}>
                    {fields.map((field, i) => cs(
                        keyed(i),
                        () => next(field),
                    ))}
                </div>
            )],
            ({field}) => {
                const ff = form.field(field.path);
                if (!field.required && readOnly && ff.state.value == null) {
                    return null;
                }
                return (
                    <div className={cx("form-group", {hasError: ff.error})}>
                        <div className={cx("control-label", {required: field.required})}>
                            {field.label}
                        </div>

                        {field.type === "Number" ? (
                            <input {...{
                                ...bindInput(scopedState(userData, [field.path])),
                                disabled: readOnly,
                                ...field.getSuggestedValue && {
                                    placeholder: field.getSuggestedValue(savedData),
                                },
                                onKeyDown: (e) => {

                                    const rejectKey = (key) => isNaN(key) && key !== ".";

                                    if (isSpecialKey(e) || e.key?.length > 1) {

                                    } else if (rejectKey(e.key)) {
                                        e.preventDefault();
                                    }
                                },
                                "xd-qa-type": "text_field",
                                "xd-qa-name": "Ad Budget Number",
                            }}/>
                        ) : field.type === "string" ? (
                            <textarea {...{
                                ...bindInput(scopedState(userData, [field.path])),
                                disabled: readOnly,
                                "xd-qa-type": "text_field",
                                "xd-qa-name": "Ad Budget Comments",
                            }}/>
                        ) : (
                            Select({
                                list: field.values,
                                itemToLabel: v=>v,
                                isSelected: v=>ff.state.value === v,
                                onChange: v=>ff.state.onChange(v),
                                style: {
                                    color: ff.error && "danger",
                                },
                                disabled: readOnly,
                                xdQaName: "Ad Budget Select",
                            })
                        )}

                        {ff.error && (
                            <div className="error">
                                {ff.error.failedValidator.name === "required" ? (
                                    "Required"
                                ) : ff.error.failedValidator.name === "isNumber" ? (
                                    "Invalid number"
                                ) : (
                                    `Max: ${ff.error.failedValidator.max}`
                                )}
                            </div>
                        )}
                    </div>
                );
            },
        ),
    }),
);

